import { coreApi, ecommerceApi, learningApi } from 'services/api'

interface IMessage {
  name: string
  email: string
  phone: string
  message: string
}

export const CHANGE_PASSWORD = async (oldPassword: string, newPassword: string) => {
  try {
    const token = localStorage.getItem('token')

    await learningApi.patch(
      '/student/auth/password',
      {
        password: oldPassword,
        newPassword: newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const SEND_MESSAGE = async (data: IMessage) => {
  try {
    await coreApi.post('integrations/hubspot/contact', {
      email: data.email,
      name: data.name,
      phone: data.phone,
      message: data.message,
      id: 'c8e74268-e01f-40c9-ac07-a5c44731cac9',
    })
  } catch (err) {
    console.log(err)
    throw err
  }
}
